export var generateFaqPath = function (faqItem) {
    if (typeof faqItem !== 'object' || faqItem === null) {
        return undefined;
    }
    return "FAQ/" + faqItem.code;
};
